var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.293 5.932a1 1 0 0 1 1.338-.068l.076.068 6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1-1.414-1.414l5.293-5.293-5.293-5.293-.069-.076a1 1 0 0 1 .069-1.338"
  })));
};
export default Svg24;